import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';
import { FOOTER_SOLUTIONS, FOOTER_COMPANY } from '@/data/mock';
import { Mail, Globe, Youtube, Linkedin, Instagram } from 'lucide-react';

export default function Footer() {
  const { currentTheme: t, theme } = useTheme();

  return (
    <footer style={{ background: t.footerBg }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_motivy-light/artifacts/y1xqcc0j_logo%20blanco%20%281%29.png"
                alt="Motivy"
                className="h-8"
              />
            </Link>
            <p className="text-sm leading-relaxed mb-6" style={{ color: t.footerTextMuted }}>
              Plataforma de capital humano y bienestar corporativo. Transformamos la motivación y productividad en tu empresa.
            </p>
            <div className="flex gap-3">
              {[
                { Icon: Linkedin, href: '#' },
                { Icon: Youtube, href: 'https://www.youtube.com/@MotivyApp' },
                { Icon: Instagram, href: '#' },
              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg flex items-center justify-center transition-colors duration-200"
                  style={{ background: 'rgba(255,255,255,0.1)', color: t.footerTextMuted }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                    e.currentTarget.style.color = '#FFFFFF';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                    e.currentTarget.style.color = t.footerTextMuted;
                  }}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: t.footerText }}>Soluciones</h4>
            <ul className="space-y-3">
              {FOOTER_SOLUTIONS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm transition-colors duration-200"
                    style={{ color: t.footerTextMuted }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
                    onMouseLeave={(e) => e.currentTarget.style.color = t.footerTextMuted}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: t.footerText }}>Empresa</h4>
            <ul className="space-y-3">
              {FOOTER_COMPANY.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm transition-colors duration-200"
                    style={{ color: t.footerTextMuted }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
                    onMouseLeave={(e) => e.currentTarget.style.color = t.footerTextMuted}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/politica-de-privacidad"
                  className="text-sm transition-colors duration-200"
                  style={{ color: t.footerTextMuted }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
                  onMouseLeave={(e) => e.currentTarget.style.color = t.footerTextMuted}
                >
                  Política de privacidad
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: t.footerText }}>Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm" style={{ color: t.footerTextMuted }}>
                <Mail size={14} />
                <span>info@motivy.co</span>
              </li>
              <li className="flex items-center gap-2 text-sm" style={{ color: t.footerTextMuted }}>
                <Globe size={14} />
                <span>motivyapp.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t flex flex-col sm:flex-row justify-between items-center gap-4" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <p className="text-xs" style={{ color: t.footerTextMuted }}>
            © 2025 Motivy. Todos los derechos reservados.
          </p>
          <Link
            to="/politica-de-privacidad"
            className="text-xs transition-colors duration-200"
            style={{ color: t.footerTextMuted }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
            onMouseLeave={(e) => e.currentTarget.style.color = t.footerTextMuted}
          >
            Política de privacidad
          </Link>
        </div>
      </div>
    </footer>
  );
}
